import React from 'react';
import { Box, Container, Skeleton, AppBar, Toolbar, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CustomizeItemSkeleton: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', bgcolor: 'background.default' }}>
    {/* AppBar Skeleton */}
    <AppBar position="sticky" sx={{ bgcolor: 'background.paper', boxShadow: '0 2px 4px -1px rgba(0,0,0,0.06), 0 4px 5px 0 rgba(0,0,0,0.04), 0 1px 10px 0 rgba(0,0,0,0.03)', borderRadius: 0 }}>
      <Toolbar>
        <IconButton edge="start" aria-label="atrás" sx={{ color: 'text.primary' }}>
          <ArrowBackIcon />
        </IconButton>
        <Skeleton variant="text" width={120} height={28} sx={{ mx: 'auto' }} />
        <Box sx={{ width: 40 }} />
      </Toolbar>
    </AppBar>

    {/* Scrollable Content Area */}
    <Box sx={{ flexGrow: 1, overflowY: 'auto', pb: '100px' }}>
      <Container maxWidth="sm" sx={{ pt: 1, pb: 2, px: 0 }}>
        {/* Item Image Skeleton */}
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height={250} 
          sx={{ mb: 2 }} 
        />
        
        <Box sx={{ px: 2 }}>
          {/* Item Name and Price Skeleton */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Skeleton variant="text" width="60%" height={32} />
            <Skeleton variant="text" width="20%" height={32} />
          </Box>
          
          {/* Description Skeleton */}
          <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="80%" height={20} sx={{ mb: 3 }} />

          {/* Options Sections Skeleton */}
          {[1, 2].map((section) => (
            <Box key={section} sx={{ mb: 3 }}>
              <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1 }} />
              {[1, 2, 3].map((option) => (
                <Box key={option} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, p: 1 }}>
                  <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="70%" height={20} />
                    <Skeleton variant="text" width="50%" height={16} />
                  </Box>
                  <Skeleton variant="rounded" width={24} height={24} />
                </Box>
              ))}
            </Box>
          ))}

          {/* Quantity Skeleton */}
          <Box sx={{ mb: 3 }}>
            <Skeleton variant="text" width="30%" height={24} sx={{ mb: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Skeleton variant="rounded" width={40} height={40} />
              <Skeleton variant="text" width={30} height={32} />
              <Skeleton variant="rounded" width={40} height={40} />
            </Box>
          </Box>

          {/* Special Instructions Skeleton */}
          <Box sx={{ mb: 3 }}>
            <Skeleton variant="text" width="50%" height={24} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>
      </Container>
    </Box>

    {/* Bottom Bar Skeleton */}
    <Box sx={{ 
      position: 'fixed', 
      bottom: 0, 
      left: 0, 
      right: 0, 
      bgcolor: 'background.paper', 
      p: 2,
      borderTop: '1px solid #e0e0e0'
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={60} height={24} />
        </Box>
        <Skeleton variant="rounded" width={120} height={40} />
      </Box>
    </Box>
  </Box>
);

export default CustomizeItemSkeleton; 